import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { ResourceRule } from "@app/models/rest/resource-rule";

@Injectable({
  providedIn: "root"
})
export class ResourceRuleRestService extends HateoasResourceOperation<ResourceRule> {
  constructor() {
    super(ResourceRule);
  }
}
